import useCalculateTimeDiff from "../../../Hooks/useCalculateTimeDiff"
import { useCart } from "../../../Providers/CartProvider"
import { useOffers } from "../../../Providers/OffersProvider"

const useCheckOtdAvailabilityByProducts = () => {
  const { cartItems } = useCart()
  const { orderItemsFromOffer } = useOffers()
  const { diffHoursFromNow } = useCalculateTimeDiff()

  /**
   * DK : Funkcja sprawdza dostępnośc produktu porównując do OTD, w razie niedostepności wyswietli komunikat
   * @param {string} expectedDeliveryTime OTD
   * @returns Czy przekroczył termin true - oznacza przekroczenie
   */
  const checkOtdAvailabilityByProducts = async (expectedDeliveryTime) => {
    if (!expectedDeliveryTime) {
      return
    }

    let products = []
    if (orderItemsFromOffer && orderItemsFromOffer.length > 0) {
      products = orderItemsFromOffer
    }
    else {
      products = cartItems.basketItems.filter(p => p.isSelected)
    }

    if (!products || products.length === 0) {
      return
    }

    const diffHours = await diffHoursFromNow(expectedDeliveryTime)
    const hasTooLongAvailability = products.some(p => {
      const availability = p.product.availabilityLevelInOtherWarehouses
      if (!availability.isAvailable && availability.productUnavailableText && availability.productUnavailableText.trim() != '') {
        try {
          const [day, month, year] = availability.productUnavailableText.slice(-10).split("-")
          const formattedDate = new Date(`${year}-${month}-${day}`)

          const formattedExpectedDate = new Date(expectedDeliveryTime.slice(0, 10))
          if (formattedDate <= formattedExpectedDate) {
            return false
          }
          else {
            return true
          }
        } catch {
          return true
        }
      }
      else {
        //sprawdzanie czy sa dostepne sztuki w makroregionach
        if (diffHours === 0 && availability.localQty === 0) {
          return true
        }
        if (diffHours === 24 && (availability.regQty === 0 && availability.localQty === 0)) {
          return true
        }
        if (diffHours <= 72 && (availability.macroQty === 0 && availability.regQty === 0 && availability.localQty === 0)) {
          return true
        }
        //sprawdzanie ilosci sztuk
        if (diffHours === 0 && p.qty > availability.localQty) {
          return true
        }
        if (diffHours === 24 && p.qty > (parseFloat(availability.localQty) + parseFloat(availability.regQty))) {
          return true
        }
        if (diffHours <= 72 && p.qty > (parseFloat(availability.localQty) + parseFloat(availability.regQty) + parseFloat(availability.macroQty))) {
          return true
        }
        try {
          //sprawdzenie OTD jeżeli zamawiamy na pozniejszy termin. Sprawdzamy czy OTD jest starszy niż dostawa od producenta
          if (diffHours > 72 && (p.qty > (parseFloat(availability.localQty) + parseFloat(availability.regQty) + parseFloat(availability.macroQty)))) {
            const [day, month, year] = availability.productUnavailableText.slice(-10).split("-")
            const formattedDate = new Date(`${year}-${month}-${day}`)

            const formattedExpectedDate = new Date(expectedDeliveryTime.slice(0, 10))
            if (formattedDate <= formattedExpectedDate) {
              return false
            }
            else {
              return true
            }
          }
        } catch (error) {
          return true
        }
        return false
      }
    })
    return hasTooLongAvailability
  }

  return { checkOtdAvailabilityByProducts }
}

export default useCheckOtdAvailabilityByProducts
